import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const ShukinKbn = props => {
  return <Dropdown.Static kubunKey='shukin_kbn' {...props} />
}
